import * as React from "react";
import {EventStore} from "../stores/events";

export const EventStoreContext = React.createContext<EventStore | null>(null);
